import BreathingExerciseContent from '@/components/Exercises/Breathing/BreathingExerciseContent';
import { Button } from '@/components/ui/button';
import { VideoWithSubtitles, type VideoWithSubtitlesRef } from '@/components/ui/VideoWithSubtitles';
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useRef, useState } from 'react';
import { useChildSessionStore } from '@/lib/stores/childSessionStore';
import { FormattedMessage } from 'react-intl';
import breathingVideo from "@/assets/videos/exercises/breathing/breathing.webm";
import breathingPoster from "@/assets/breathing-poster.png";
import { ExerciseLayout } from '@/components/ui/exercise-layout';

export const Route = createFileRoute(
  '/(content)/children/exercises/(shared)/guided-relaxation/',
)({
  component: RouteComponent,
head: () => ({
    meta: [{ title: "Guided Relaxation & Breathing Exercise - HAMD" }],
  }),
  beforeLoad: () => ({
    title: "breathing.guidedRelax.title",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  const [showOverlay, setShowOverlay] = useState(false);
  const videoRef = useRef<VideoWithSubtitlesRef>(null);
  const { selectedEmotionId, reset } = useChildSessionStore();
  const navigate = useNavigate();

  const subtitleTracks = [
    {
      src: "/subs/breathing.ar.vtt",
      srcLang: "ar",
      label: "العربية",
      default: true
    }
  ];

  const startExercise = () => {
    setShowOverlay(true);
    videoRef.current?.video?.pause();
  };

  const handleComplete = () => {
    setShowOverlay(false);
    videoRef.current?.resetVideo();
    if (selectedEmotionId) {
      navigate({ to: "/children/session" });
    }
  };

  const handleExit = () => {
    setShowOverlay(false);
    videoRef.current?.resetVideo();
    if (selectedEmotionId) {
      reset();
      navigate({ to: "/children/exercises" });
    }
  };

  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <Button className="w-full" onClick={startExercise}>
          <FormattedMessage id="breathing.startExercise" />
        </Button>
      }
    >
      <div className="space-y-7.5">
        <div>
          <h3 className="text-h3 font-medium">
            <FormattedMessage id="breathing.intro.title" />
          </h3>
          <p className="text-small">
            <FormattedMessage id="breathing.intro.subtitle" />
          </p>
        </div>
        <VideoWithSubtitles
          ref={videoRef}
          src={breathingVideo}
          poster={breathingPoster}
          subtitleTracks={subtitleTracks}
          loop={false}
        />
      </div>

      <BreathingExerciseContent
        onClose={handleComplete}
        onExit={handleExit}
        isShow={showOverlay}
      />
    </ExerciseLayout>
  );
}

export default RouteComponent;
